import schema from "./schema.json";

// export type DatabaseSchema = {
//   SCHEMA: string,
//   TABLE_NAME: string,
//   COLUMN_ID: number,
//   COLUMN_NAME: string,
//   DATA_TYPE: string,
//   NOT_NULL: string,
//   PRIMARY_KEY: string,
//   COMMENTS: string | null,
// };

export const getSchema = () => {
  return schema;
};
